// extracted by mini-css-extract-plugin
export default {"link":"SocialMediaLink_link__1nKi5","icons":"SocialMediaLink_icons__L-ZAw"};